export const GET_FAQLISTBLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    faqListBlock(id: "${id}", preview: ${preview}) {
      categories
      name
      heading
      text {
        json
        links {
          entries {
            hyperlink {
              ... on Page {
                sys {
                  id
                }
                slug
                content {
                  __typename
                }
              }
            }
          }
        }
      }
      numberOfItems
      sortBy
      includeDynamicFaqs
      linkOnFaqList {
        linkText
        variant
        buttonVariant
        globalLinkItem
        reference {
          ...on Page {
            content {
              __typename
            }
            slug
          }
          ...on FileBlock
          {
            imageVaultFile
          }
        }
        url
      }
      audienceCollection{
        items{
            __typename
            sys{id}
            audianceId
          }
      }
      manualPostsCollection {
        items {
          sys {
            id
          }
          __typename
        }
      }
      contentfulMetadata {
        concepts {
          id
        }
      }
    }
  }
`;
